var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgDiners = _a => {
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    width: size || 24,
    height: size || 24,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: props.role,
    "aria-hidden": props['aria-hidden'] || true
  }, props), React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#F6F6F6"
  }), React.createElement("circle", {
    cx: 14.35,
    cy: 15.85,
    r: 7.85,
    fill: "white"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.0098 12.3896C10.8927 12.4915 10.7601 12.5977 10.6552 12.7107C9.88794 13.5317 9.41987 14.6332 9.41748 15.8461C9.41987 17.0595 9.89636 18.1612 10.6642 18.982C10.7686 19.0943 10.8913 19.2001 11.0078 19.3016C11.4112 19.6547 11.7766 19.9402 12.338 20.1361C12.323 20.1306 12.2694 20.1237 12.2694 20.1181V11.573C12.2694 11.5674 12.323 11.5605 12.338 11.5552C11.7766 11.751 11.413 12.0366 11.0098 12.3896Z",
    fill: "#2980B9"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.5661 11.5547C15.5725 11.5574 15.4974 11.5604 15.4974 11.5631V20.1297C15.4974 20.1322 15.5725 20.1355 15.5661 20.138C17.2503 19.4748 18.5158 17.8055 18.5189 15.8461C18.5158 13.8872 17.2503 12.2166 15.5661 11.5547Z",
    fill: "#2980B9"
  }), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M18.6222 21.4428C18.5325 21.5166 18.4413 21.5885 18.3482 21.6581C17.1382 22.5631 15.6362 23.0991 14.0086 23.0996C12.3815 23.0991 10.8797 22.5631 9.67004 21.6581C9.57698 21.5885 9.48561 21.5166 9.39621 21.4428C7.78456 20.1124 6.75747 18.0996 6.75691 15.8462C6.75719 14.8444 6.96014 13.8902 7.32716 13.0225C7.37319 12.914 7.42147 12.8069 7.47256 12.7012C7.57432 12.4897 7.68604 12.2841 7.80716 12.0846C7.86779 11.9848 7.93067 11.8867 7.99579 11.7903C8.1913 11.5009 8.40716 11.2264 8.64112 10.9687C8.71916 10.8829 8.79916 10.7989 8.88126 10.7168C9.04519 10.5527 9.21698 10.3965 9.39621 10.2487C9.48561 10.1747 9.57698 10.1029 9.67004 10.0334C9.94919 9.82456 10.2439 9.63523 10.5521 9.46779C10.6549 9.41193 10.7592 9.35846 10.8648 9.30751C11.8159 8.84912 12.8822 8.592 14.0086 8.59172C15.1353 8.592 16.202 8.84912 17.1531 9.30751C17.2588 9.35846 17.3631 9.41193 17.4658 9.46779C17.7742 9.63523 18.0689 9.82456 18.3482 10.0334C18.4413 10.1029 18.5325 10.1747 18.6222 10.2487C18.8011 10.3965 18.9731 10.5527 19.1371 10.7168C19.2191 10.7989 19.2992 10.8829 19.3773 10.9687C19.6114 11.2264 19.8272 11.5009 20.0227 11.7903C20.0877 11.8867 20.1507 11.9848 20.2112 12.0846C20.3325 12.2841 20.4442 12.4897 20.5461 12.7012C20.5969 12.8069 20.6455 12.914 20.6912 13.0225C21.0582 13.8902 21.2613 14.8444 21.2615 15.8462C21.2612 18.0996 20.2338 20.1124 18.6222 21.4428ZM17.7186 8H13.991C9.60786 8 6 11.2027 6 15.9284C6 20.2519 9.60786 23.8596 13.991 23.7193H17.7186C22.0498 23.8596 26.0031 20.2508 26.0031 15.9284C26.0031 11.2017 22.0498 8 17.7186 8Z",
    fill: "#2980B9"
  }));
};
export default SvgDiners;